import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { CompanyService } from '../../../rent/service/data/company.service';
import { InvoiceTransaction } from '../../model/invoice-transaction';
import { InvoiceTransactionService } from '../../service/data/invoice-transaction.service';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { invoiceTransactionCommand } from '../../command/transaction-invoice';
import { InvoiceTransactionCommandHandlerResolver } from '../../service/command/invoice-transaction-command-handler-resolver.service';
import { LocalDate } from '../../../core/model/local-date';
import { ColumnVisibility } from '../../../core/model/column-definition';

@Component({
    selector: 'app-bg-payment-manager',
    templateUrl: './bg-payment-manager.component.html',
    styleUrls: ['./bg-payment-manager.component.scss'],
    providers: [InvoiceTransactionCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BgPaymentManagerComponent extends MultiselectObjectManagerComponentBase<InvoiceTransaction> {
  constructor(
    private _companyRepository: CompanyService,
    private invoiceTransactionService: InvoiceTransactionService,
    fb: FormBuilder,
    fcf: FormControlExFactory,
    messageService: MessageService,
    navigation: NavigationService,
    cdf: ColumnDefinitionFactory,
    dispatcher: CommandDispatcher,
    handlerResolver: InvoiceTransactionCommandHandlerResolver
  ) {
    super(invoiceTransactionService, dispatcher, handlerResolver, messageService, navigation);

    this.companyService = _companyRepository;

    this.columnDefinition = [
      cdf.createDate('PAYMENT.DATE', 'businessTransactionDate'),
      cdf.createDate('INVOICE.DUE_DATE', 'invoiceDueDate'),
      cdf.create('INVOICE.PERIOD', 'invoiceRefersToPeriod', ColumnVisibility.optional),
      cdf.create('ACCOUNT_TRANSACTION.DESCRIPTION', 'verificationDescription'),
      cdf.create('INVOICE.RECIPIENT_NAME', 'debtorName'),
      cdf.createMoney('PAYMENT.AMOUNT', 'amount'),
      cdf.createMoney('INVOICE.INVOICEAMOUNT', 'invoiceAmount'),
      cdf.createMoney('INVOICE.REMAINING_AMOUNT', 'invoiceUnPaidAmount'),
      cdf.createMoney('INVOICE.PREVIEW.VAT', 'invoiceVatAmount', ColumnVisibility.optional),
      cdf.create('PAYMENT.PAYER_NAME', 'paymentNameAndAddress'),
      cdf.create('PAYMENT.REGISTRATION_TYPE', 'registrationTypeText', ColumnVisibility.optional),
    ];

    this.menuDefinition = [new MenuItemDefinition('LEASE_AGREEMENT.COMMAND.EXPORT', invoiceTransactionCommand.export)];

    this.from = LocalDate.today();
    this.from.addDays(-7);

    this.to = LocalDate.today();

    this.filter = fb.group({
      from: fb.group({}),
      to: fb.group({}),
      company: fcf.create('COMMON.COMPANY', null),
      verDescription: fcf.create('ACCOUNT_TRANSACTION.DESCRIPTION', null),
      debtorName: fcf.create('INVOICE.RECIPIENT_NAME', null),
      dueDateFrom: fb.group({}),
      dueDateTo: fb.group({}),
    });

    this.title = 'PAYMENT.BG_PAYMENTS';
  }

  from: LocalDate;
  to: LocalDate;
  companyService: CompanyService;

  ngOnInit() {
    this.filter.markAsDirty();
  }
}
